module.exports = __webpack_public_path__ + "media/images/features/wedding-ceremony-cost/bycost-image-250000-31f7825caa402f6468b22aa9a2e0e34a.png";